import { useActiveOrg } from '~/hooks/org'

export const useActiveOrgSmartAccountsSetup = () => {
  const { org: activeOrg } = useActiveOrg()
  return activeOrg?.smartAccountSetup
}
